import { BookOpenTextIcon, CalendarCheckIcon, CalendarXIcon, ClipboardCheckIcon, FileTextIcon, FolderSearchIcon, GlobeIcon, LayersIcon, LayoutGridIcon, MapIcon, PencilRulerIcon, ShuffleIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

// =====================================================================
// SLOTS DE IMÁGENES – PENDIENTES (los completa la sesión principal)
// Pegar URLs WebP (Recursos Impultienda). Mientras estén vacías, la landing
// muestra placeholders neutros dibujados con CSS (sin imágenes de otra materia).
// =====================================================================

// SLOT MOCKUP: caja/pila de las 6 volymer SO KLAR (réplica del mockup de MATTE KLAR), PNG/WebP transparente.
export const MOCKUP_URL = '';

// SLOT PAGINAS: 5 páginas reales del Volym 1 para "Titta inuti" (mismo orden que pageTexts más abajo).
// 1 lärarsida · 2 elevblad i 3 nivåer · 3 årsplanering · 4 prov med facit · 5 bedömningsmatris
// Si la página elegida es otra lektion/årskurs, ajustar también title/text en pageTexts.
export const PAGE_URLS: string[] = ['', '', '', '', ''];

// ---------- Images ----------
export const PRODUCT_IMAGE = MOCKUP_URL;
export const PRODUCT_IMAGE_ALT = 'SO KLAR-paketet: sex SO-volymer för åk 1–9 i geografi, historia, religionskunskap och samhällskunskap med lektioner, arbetsblad, kartor, tidslinjer, prov och facit';

// ---------- Prices ----------
export const PRICE = '299 kr';
export const ORIGINAL_PRICE = '601 kr';

// ---------- Meta ----------
export const META = {
  title: 'SO KLAR™ – Färdiga SO-lektioner för åk 1–9',
  description: 'Färdigt 6-i-1-system för SO åk 1–9: 6 volymer, 240 sidor, 12 lektioner minut för minut, arbetsblad i 3 nivåer, färdiga kartor och tidslinjer, prov A/B med facit och 5 bonusar. 299 kr.',
  ogTitle: 'SO KLAR™ – Gå in i SO-lektionen med allt klart',
  ogDescription: 'Hela läsåret i SO – färdigplanerat. Geografi, historia, religionskunskap och samhällskunskap för åk 1–9 med lektioner, arbetsblad, kartor, tidslinjer och prov med facit. Omedelbar nedladdning.'
};

// ---------- Top bar (honest: no countdown) ----------
export const topBar = {
  long: 'Introduktionspris 299 kr · Engångsbetalning · 7 dagars nöjdhetsgaranti',
  short: 'Introduktionspris 299 kr · 7 dagars garanti'
};

// ---------- Section copy ----------
export const copy = {
  ctaDefault: 'Skaffa SO KLAR™ nu',
  hero: {
    before: 'Få',
    highlight: 'hela läsåret',
    middle: 'i SO färdigplanerat – kom igång på',
    accent: '5 minuter',
    sub: 'Sluta planera från grunden. Sex digitala volymer för åk 1–9 i geografi, historia, religionskunskap och samhällskunskap med färdiga lektioner, arbetsblad i tre nivåer, kartor, tidslinjer, prov och facit – plus fem bonusar.',
    badgeLine1: '6 volymer',
    badgeLine2: '+ 5 bonusar'
  },
  stats: { title: 'Det kompletta paketet i siffror' },
  difference: {
    kicker: 'Skillnaden med SO KLAR™',
    titleStart: 'Från stressad lärare till',
    titleAccent: 'trygg och förberedd.',
    intro: 'Tänk dig att börja veckan med SO-lektionerna redan organiserade. Du vet vad du ska undervisa om – och du har lektionsupplägget, arbetsbladen, kartorna, tidslinjerna, proven och facit.',
    beforeLabel: 'Innan SO KLAR™',
    beforeTitle: 'Känner du igen dig?',
    afterLabel: 'Med SO KLAR™',
    afterTitle: 'Planera mindre. Undervisa mer.',
    closing: 'Fokusera på dina elever – inte på att skapa allt material själv.'
  },
  recognize: {
    title: 'Har du någonsin upplevt det här?',
    text: 'Om du svarar ja på minst en fråga är SO KLAR™ för dig.',
    link: 'Du förtjänar ett enklare sätt'
  },
  inside: {
    title: 'Vad innehåller',
    brand: 'SO KLAR™',
    packTitle: 'Vad gör SO KLAR™ annorlunda?',
    packText: 'Ett helt läsårs SO-material – organiserat och redo att använda.'
  },
  pages: {
    kicker: 'Titta inuti SO KLAR™',
    titleStart: 'Se hur materialet ser ut',
    titleAccent: 'på insidan.',
    text: 'Exempel på sidor ur materialet: lärarsidor minut för minut, elevblad i tre nivåer, årsplanering, prov och bedömning – skapade för att användas i SO-undervisningen.'
  },
  bonuses: {
    kicker: 'Men det finns mer!',
    titleStart: '5 bonusar',
    titleAccent: 'utan extra kostnad',
    text: 'Fem extra resurser ingår tillsammans med dina sex volymer – så att du kan organisera och genomföra SO-undervisningen ännu enklare.'
  },
  how: {
    titleStart: 'Så fungerar',
    brand: 'SO KLAR™',
    text: 'Från nedladdning till klassrummet: förbered nästa SO-lektion på bara fem minuter.',
    closing: 'Öppna → välj → förbered → undervisa. Enkelt och strukturerat.'
  },
  audience: {
    titleStart: 'För vem är',
    brand: 'SO KLAR™',
    lead: 'Paketet är för dig som:',
    closing: 'Skapat för lärare som vill lägga mindre tid på förberedelser och mer tid på eleverna.',
    asideTitle: 'Vad är din tid värd?',
    asideLead: 'Tänk på hur många timmar du lägger på SO-planering varje vecka:',
    asideText: 'Tänk dig nu ett organiserat paket som hjälper dig med allt detta – under hela läsåret.',
    asideClosing: 'Du behöver inte fortsätta börja från noll.'
  },
  offer: {
    titleStart: 'Upptäck ditt kompletta',
    brand: 'SO KLAR™',
    titleEnd: '-paket',
    text: 'Hela läsåret i SO – färdigplanerat. Kom igång på 5 minuter.',
    includesLabel: 'Det kompletta paketet innehåller',
    priceLabel: 'Introduktionspris',
    originalLabel: 'Ord. pris',
    oneTime: 'Engångsbetalning. Ingen prenumeration.',
    cta: 'Skaffa hela paketet nu'
  },
  guarantee: {
    title: '7 dagars nöjdhetsgaranti',
    text: 'Ladda ner materialet och se hur det fungerar i din SO-undervisning. Om paketet inte motsvarar dina förväntningar kan du kontakta oss via e-post och begära återbetalning inom 7 dagar från köpet, enligt våra garantivillkor.',
    legal: 'Garantin påverkar inte dina rättigheter enligt gällande konsumentlagstiftning.'
  },
  finalCta: {
    titleStart: 'Din SO-undervisning kan vara',
    titleAccent: 'redo redan idag.',
    text: 'I stället för att leta efter kartor, rita tidslinjer och skapa varje arbetsblad själv på kvällarna har du ett organiserat SO-paket för hela läsåret. Mer tid till det som verkligen betyder något:',
    closing: 'Dina elever. Din undervisning. Ditt liv utanför skolan.',
    recap: ['6 volymer', '5 bonusar', '240 sidor', 'Åk 1–9'],
    oneTime: 'Engångsbetalning – ingen prenumeration.',
    reassurances: ['Omedelbar digital nedladdning', 'Utskrivbara PDF-filer', '7 dagars nöjdhetsgaranti']
  },
  footer: {
    brand: 'SO KLAR',
    disclaimer: 'SO KLAR™ är ett fristående undervisningsmaterial i SO (geografi, historia, religionskunskap och samhällskunskap) för åk 1–9. Materialet bygger på det centrala innehållet i Lgr22.',
    copyright: '© 2026 SO KLAR™ · edulabs. Alla rättigheter förbehållna.'
  }
};

// ---------- Data ----------
export const heroGuarantees = ['Omedelbar digital nedladdning', 'Engångsbetalning', 'Ingen prenumeration', '7 dagars nöjdhetsgaranti'];

export const stats = [{
  value: '240',
  label: 'Sidor i huvudvolymerna'
}, {
  value: '6',
  label: 'Digitala SO-volymer'
}, {
  value: '12',
  label: 'Lektioner minut för minut'
}, {
  value: '100',
  label: 'Färdiga kommentarer till omdömen'
}, {
  value: '5',
  label: 'Bonusar som ingår'
}];

export const differenceStats = [{
  value: 'Åk 1–9',
  label: 'Årsplanering för åk 1–3, 4–6 och 7–9'
}, {
  value: '6 digitala volymer',
  label: 'Planering, geografi, historia, religionskunskap, samhällskunskap och bedömning'
}, {
  value: 'Utskrivbara PDF-filer',
  label: 'Att använda digitalt eller skriva ut i klassrummet'
}];

export const beforeItems: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Kvällarna försvinner',
  text: 'Timmar framför datorn för att planera nästa veckas SO-lektioner – och du är fortfarande inte klar.'
}, {
  title: 'Timmar av letande efter kartor',
  text: 'Kartor, bilder och tidslinjer från olika webbplatser är för svåra, för enkla eller passar inte din årskurs.'
}, {
  title: 'Arbetsbladen skapas från grunden',
  text: 'Frågor, källor, uppställning och facit – det som skulle ta minuter blir en lång arbetsuppgift.'
}, {
  title: 'Fyra ämnen att hålla ihop',
  text: 'Geografi, historia, religionskunskap och samhällskunskap – varje ämne kräver egna lektioner, egna arbetsblad och egna prov.'
}, {
  title: 'Prov och rättning tar tid',
  text: 'Prov för fyra ämnen, facit och omdömen blir ännu mer arbete efter skoltid.'
}, {
  title: 'Osäkerhet inför känsliga frågor',
  text: 'Religion, migration, krig och politik – det tar tid att hitta material som är sakligt och neutralt.'
}];

export const afterItems = ['Ett organiserat SO-paket för hela grundskolan', 'Årsplanering för åk 1–3, 4–6 och 7–9', '12 lektioner planerade minut för minut', 'Arbetsblad i 3 nivåer som kan skrivas ut direkt', 'Färdiga kartor och tidslinjer', 'Geografi, historia, religionskunskap och samhällskunskap samlat på ett ställe', 'Sakligt och neutralt material i religion och samhälle', 'Prov A/B med facit och bedömningsmatriser E/C/A', '100 färdiga kommentarer till omdömen'];

export const recognizeItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: CalendarXIcon,
  title: 'Kvällarna går åt till planering',
  text: 'Sitter du på kvällar och helger och planerar nästa veckas SO-lektioner?'
}, {
  icon: FolderSearchIcon,
  title: 'Du letar efter kartor och källor',
  text: 'Söker du ständigt efter kartor, tidslinjer och texter som passar dina elever?'
}, {
  icon: LayersIcon,
  title: 'Fyra ämnen att planera',
  text: 'Ska du hålla ihop geografi, historia, religionskunskap och samhällskunskap – och skapa prov för alla fyra?'
}, {
  icon: PencilRulerIcon,
  title: 'Du vill slippa skapa allt från noll',
  text: 'Önskar du att lektioner, arbetsblad och prov redan var förberedda?'
}, {
  icon: ShuffleIcon,
  title: 'Eleverna ligger på olika nivåer',
  text: 'Behöver du uppgifter som fungerar både för elever som behöver stöd och för dem som vill ha mer utmaning?'
}, {
  icon: LayoutGridIcon,
  title: 'Du behöver en tydligare struktur',
  text: 'Vill du ha materialet samlat så att du snabbt hittar det du behöver?'
}];

// Spine colours mirror the physical box (blue, light blue, green, yellow, orange, red).
export const volumes: Array<{
  number: string;
  level: string;
  title: string;
  tagline: string;
  intro: string;
  items: string[];
  outro: string;
  note?: string;
  spine: string;
  rule: string;
}> = [{
  number: 'Volym 01',
  level: 'Planering',
  title: 'Årsplanering + 12 lektioner minut för minut',
  tagline: 'Gå in i SO-lektionen med allt klart.',
  intro: 'Den första volymen ger dig strukturen för hela läsåret och tolv färdiga lektioner på 60 minuter i de fyra SO-ämnena – med lärarsida och elevblad i tre nivåer till varje lektion.',
  items: ['Årsplanering för åk 1–3 (SO integrerat), 4–6 och 7–9', 'Terminsplanering vecka för vecka', '12-veckorsplan och progressionstabell', '12 lektioner minut för minut (60 min)', 'Lärarsida + elevblad i 3 nivåer', 'Prov', 'Facit (lärarexemplar)', 'Bedömningsmatris'],
  outro: 'Från ”Min familj och mina rättigheter” i åk 1 till ”Källkritik och nyheter” i åk 9 – färdigt att undervisa.',
  spine: 'bg-blue-700 text-white',
  rule: 'border-white/30'
}, {
  number: 'Volym 02',
  level: 'Geografi',
  title: 'Kartor, Sverige, världen & hållbar utveckling',
  tagline: 'Hjälp eleverna att hitta i världen.',
  intro: 'Den andra volymen innehåller färdiga lektioner, kartövningar och arbetsblad i geografi för åk 1–9.',
  items: ['Kartkunskap och gradnät', 'Sveriges och Nordens geografi', 'Världsdelar och världshav', 'Klimat och vegetationszoner', 'Befolkning och migration', 'Naturresurser och hållbar utveckling', 'Jordens inre krafter', 'Kartövningar med facit'],
  outro: 'Färdiga kartor och övningar som gör geografin konkret.',
  spine: 'bg-sky-500 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Volym 03',
  level: 'Historia',
  title: 'Från förhistorisk tid till Sverige efter 1945',
  tagline: 'Gör historien levande – med tidslinjer och källor.',
  intro: 'Den tredje volymen innehåller färdiga lektioner, tidslinjer och arbetsblad i historia – från de första människorna till vår egen tid.',
  items: ['Historiska källor och tidslinjer', 'Förhistorisk tid', 'Vikingatiden', 'Medeltiden', 'Gustav Vasa och reformationen', 'Stormaktstiden', '1700-talet och upplysningen', 'Industrialisering och utvandring', 'Demokratins genombrott och rösträtt', 'Världskrigen och kalla kriget', 'Sverige efter 1945'],
  outro: 'Tydliga sammanhang och tidslinjer för historieundervisningen i åk 1–9.',
  spine: 'bg-green-600 text-white',
  rule: 'border-white/30'
}, {
  number: 'Volym 04',
  level: 'Religion',
  title: 'Världsreligioner, livsfrågor & etik',
  tagline: 'Sakligt, neutralt och respektfullt.',
  intro: 'Den fjärde volymen innehåller färdiga lektioner och arbetsblad i religionskunskap – med ett sakligt och neutralt förhållningssätt till alla religioner och livsåskådningar.',
  items: ['Kristendom', 'Judendom', 'Islam', 'Hinduism', 'Buddhism', 'Fornnordisk religion och samisk religion', 'Högtider och riter', 'Religion i Sverige i dag', 'Livsfrågor', 'Etik: konsekvensetik, pliktetik och dygdetik'],
  outro: 'Ett tryggt stöd för att undervisa om religioner och etik.',
  spine: 'bg-yellow-400 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Volym 05',
  level: 'Samhälle',
  title: 'Demokrati, rättigheter, ekonomi & media',
  tagline: 'Förklara hur samhället fungerar.',
  intro: 'Den femte volymen innehåller färdiga lektioner och arbetsblad i samhällskunskap – partipolitiskt neutralt och anpassat för åk 1–9.',
  items: ['Demokrati och diktatur', 'Riksdag, regering, region och kommun', 'Val och partier', 'Lag och rätt', 'Mänskliga rättigheter och barnkonventionen', 'Privatekonomi och samhällsekonomi', 'Media och källkritik', 'FN och EU', 'Hållbar samhällsutveckling'],
  outro: 'Konkreta exempel som gör samhällskunskapen begriplig.',
  spine: 'bg-orange-500 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Volym 06',
  level: 'Bedömning',
  title: 'Prov, facit & bedömningsmatriser',
  tagline: 'Gör bedömningen enklare och tydligare.',
  intro: 'Den sjätte volymen innehåller prov i två versioner per ämne och åk-grupp, facit och färdigt stöd för bedömning och omdömen.',
  items: ['Prov A/B per ämne och åk-grupp', 'Facit', 'Bedömningsmatriser E/C/A', 'Åk 1–3: på väg / når / fördjupar', 'Självbedömning och formativ bedömning', '100 färdiga kommentarer till omdömen och IUP'],
  outro: 'Mindre tid på rättning – tydligare uppföljning.',
  spine: 'bg-red-600 text-white',
  rule: 'border-white/30'
}];

export const volumesIntro = {
  title: '6 digitala volymer för åk 1–9',
  text: 'Ett komplett SO-paket i geografi, historia, religionskunskap och samhällskunskap som hjälper dig att planera och genomföra undervisningen under hela läsåret. Varje volym innehåller 40 sidor med lektioner, arbetsblad, kartor, tidslinjer och bedömningsmaterial.'
};

export const packItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: BookOpenTextIcon,
  title: 'Lektioner minut för minut',
  text: 'Slipp börja från ett tomt dokument. 12 lektioner på 60 minuter med lärarsida och elevblad – plus färdiga lektioner i varje volym.'
}, {
  icon: FileTextIcon,
  title: 'Arbetsblad i 3 nivåer',
  text: 'Utskrivbara arbetsblad i tre nivåer – så att alla elever kan arbeta med samma innehåll.'
}, {
  icon: MapIcon,
  title: 'Färdiga kartor och tidslinjer',
  text: 'Kartövningar och tidslinjer klara att skriva ut – från närområdet och Sverige till världen och historiens epoker.'
}, {
  icon: GlobeIcon,
  title: 'Fyra SO-ämnen i ett system',
  text: 'Geografi, historia, religionskunskap och samhällskunskap samlade – och i åk 1–3 integrerat, precis som i Lgr22.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Prov A/B med facit',
  text: 'Färdiga prov i två versioner, facit, bedömningsmatriser E/C/A och självbedömning som stöd för rättning och uppföljning.'
}, {
  icon: CalendarCheckIcon,
  title: 'Årsplanering',
  text: 'Årsplanering för åk 1–3, 4–6 och 7–9, planering vecka för vecka och progressionstabell.'
}];

// Textos de las 5 páginas "Titta inuti" (SLOT PAGINAS: ajustar si se eligen otras páginas del Volym 1)
const pageTexts: Array<{ label: string; title: string; text: string }> = [{
  label: 'Lärarsida – lektion minut för minut',
  title: 'Lektion 4: Sveriges landskap och kartans väderstreck (åk 4)',
  text: 'En hel lektion på 60 minuter planerad steg för steg – från start och genomgång till arbete och avslutning.'
}, {
  label: 'Elevblad i 3 nivåer',
  title: 'Vikingatiden – handel och resor (åk 4)',
  text: 'Samma innehåll i tre nivåer, så att alla elever kan arbeta med lektionen.'
}, {
  label: 'Årsplanering',
  title: 'Årsplanering åk 4–6',
  text: 'Arbetsområden i geografi, historia, religionskunskap och samhällskunskap fördelade över läsåret.'
}, {
  label: 'Prov med facit',
  title: 'Prov åk 7–9 med facit',
  text: 'Färdigt prov och facit (lärarexemplar) för snabb rättning och genomgång.'
}, {
  label: 'Bedömningsmatris',
  title: 'Bedömningsmatris E/C/A',
  text: 'Tydliga kriterier för bedömning – och för åk 1–3: ”på väg / når / fördjupar”.'
}];

export const pageSamples: Array<{ src: string; label: string; title: string; text: string }> = pageTexts.map((page, index) => ({
  ...page,
  src: PAGE_URLS[index] || ''
}));

export const pageTypes = ['Lektioner minut för minut', 'Elevblad i 3 nivåer', 'Kartor och tidslinjer', 'Prov och facit'];

export const bonuses: Array<{
  title: string;
  text: string;
  items: string[];
  benefit: string;
}> = [{
  title: 'SO-start på 5 minuter',
  text: '40 korta uppstarter som får igång lektionen direkt – med facit.',
  items: ['10 ”Vem är jag?”', '10 kartfrågor', '10 ”Vad hände sen?” (tidslinje)', '10 ”Dagens fråga”'],
  benefit: 'Starta varje SO-lektion med fokus – utan extra förberedelse.'
}, {
  title: 'Källkritik på 10 minuter: 30 färdiga övningar',
  text: 'Korta övningar som tränar eleverna att granska information – för åk 4–9, med facit.',
  items: ['Falska nyheter', 'Bildmanipulation', 'Reklam eller fakta?', 'Vem är avsändaren?', 'Sociala medier'],
  benefit: 'Källkritik som vana – i små, färdiga steg.'
}, {
  title: 'Föräldrakommunikation i SO',
  text: 'Färdiga texter för kontakten med vårdnadshavare under hela läsåret.',
  items: ['Färdiga brev', 'Veckobrev', 'Information om studiebesök och känsliga ämnen', 'Mall för utvecklingssamtal'],
  benefit: 'Tydlig kommunikation på några minuter.'
}, {
  title: 'Vikariepärm för SO',
  text: '15 lektioner som vikarien kan genomföra utan förberedelse.',
  items: ['15 färdiga lektioner', 'Instruktioner', 'Arbetsblad', 'Facit'],
  benefit: 'Lugn och ro även när du inte kan vara på plats.'
}, {
  title: 'Affischer för SO-salen',
  text: '20 affischer som gör klassrummet till en lärmiljö.',
  items: ['Världskartan', 'Sveriges landskap', 'Sveriges historia på en tidslinje', 'Världsreligionerna', 'Så styrs Sverige', 'Barnkonventionen', 'Källkritik-checklista', 'Väderstreck', 'Ordlista'],
  benefit: 'Skriv ut och sätt upp – direkt.'
}];

export const steps: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Öppna SO KLAR™',
  text: 'Ladda ner paketet och öppna volymen du behöver – planering, geografi, historia, religionskunskap, samhällskunskap eller bedömning.'
}, {
  title: 'Välj lektion och material',
  text: 'Hitta rätt arbetsområde och välj lektion, elevblad i rätt nivå, karta eller tidslinje.'
}, {
  title: 'Förbered dig på 5 minuter',
  text: 'Gå igenom lärarsidan och välj det material du behöver.'
}, {
  title: 'Skriv ut och undervisa',
  text: 'Skriv ut elevbladen eller använd materialet digitalt – och gå in i SO-lektionen med en tydlig plan.'
}];

export const audienceItems = ['Undervisar i SO i åk 1–3, 4–6 eller 7–9', 'Undervisar i geografi, historia, religionskunskap eller samhällskunskap', 'Vill ha ett helt läsårs SO-material organiserat', 'Vill slippa skapa varje arbetsblad från grunden', 'Behöver färdiga kartor och tidslinjer', 'Vill ha arbetsblad i olika nivåer', 'Vill ha färdiga prov, facit och bedömningsmatriser', 'Vill känna sig bättre förberedd inför undervisningen'];

export const timeValueTasks = ['Leta efter kartor och källor', 'Rita tidslinjer', 'Skriva arbetsblad i olika nivåer', 'Skapa prov för fyra SO-ämnen', 'Rätta och skriva omdömen'];

export const offerRows: Array<{
  label: string;
  detail: string;
}> = [{
  label: '6 digitala volymer – 240 sidor',
  detail: 'Årsplanering, geografi, historia, religionskunskap, samhällskunskap och bedömning'
}, {
  label: '5 bonusar utan extra kostnad',
  detail: 'SO-start, källkritik, föräldrakommunikation, vikariepärm och affischer'
}, {
  label: 'För åk 1–9',
  detail: '12 lektioner minut för minut, arbetsblad i 3 nivåer, kartor, tidslinjer och prov A/B med facit'
}];

export const offerIncludes = ['Omedelbar digital nedladdning', 'PDF-filer att spara', 'Utskrivbara arbetsblad', 'Ingen fysisk produkt skickas'];

// No buyers yet: only add authentic reviews of SO KLAR. The section stays hidden while empty.
export const testimonials: Array<{
  quote: string;
  name: string;
  location: string;
}> = [];

export const faqs = [{
  q: 'Hur får jag materialet?',
  a: 'SO KLAR™ levereras digitalt. Efter köpet får du tillgång till PDF-filer som du kan ladda ner och spara. Du kan använda materialet på dator, surfplatta eller mobil och skriva ut de sidor du behöver.'
}, {
  q: 'Vilka ämnen ingår?',
  a: 'SO KLAR™ täcker de fyra SO-ämnena: geografi (volym 2), historia (volym 3), religionskunskap (volym 4) och samhällskunskap (volym 5). Dessutom ingår årsplanering med 12 lektioner minut för minut (volym 1) och en volym med bedömning (volym 6).'
}, {
  q: 'Hur fungerar det i åk 1–3?',
  a: 'I åk 1–3 är SO integrerat. Årsplaneringen för åk 1–3 utgår från de fyra områdena Att leva tillsammans, Att leva i närområdet, Att leva i världen och Att undersöka verkligheten – med lektioner och elevblad anpassade för de yngre eleverna.'
}, {
  q: 'Och i åk 4–6 och 7–9?',
  a: 'Från åk 4 arbetar du med geografi, historia, religionskunskap och samhällskunskap var för sig. Du får årsplanering för åk 4–6 och 7–9 och väljer material per ämne utifrån den årskurs du undervisar i.'
}, {
  q: 'Bygger materialet på Lgr22?',
  a: 'Ja. SO KLAR™ bygger på det centrala innehållet i Lgr22 för SO-ämnena i åk 1–9. Bedömningsmatriserna utgår från betygsstegen E/C/A, och för åk 1–3 används ”på väg / når / fördjupar”. SO KLAR™ är ett fristående undervisningsmaterial.'
}, {
  q: 'Hur hanteras religion och känsliga frågor?',
  a: 'Religionskunskapen är saklig, neutral och respektfull – ingen religion eller livsåskådning värderas över någon annan. Samhällskunskapen är partipolitiskt neutral.'
}, {
  q: 'Kan jag verkligen förbereda en lektion på 5 minuter?',
  a: 'SO KLAR™ är utformat för att göra lektionsförberedelserna snabbare. Du kan öppna en volym, välja en färdig lektion eller ett elevblad och gå igenom lärarsidan på ungefär fem minuter. Tiden kan variera beroende på lektionsinnehåll och elevgrupp.'
}, {
  q: 'Räcker materialet för ett helt läsår?',
  a: 'SO KLAR™ innehåller årsplanering och material som kan användas under hela läsåret. Du väljer, kombinerar och anpassar resurserna efter din planering och elevernas behov.'
}, {
  q: 'Ingår facit?',
  a: 'Ja. Proven finns i version A och B med facit, och paketet innehåller även bedömningsmatriser, självbedömning och 100 färdiga kommentarer till omdömen.'
}, {
  q: 'Kan jag använda materialet för elever på olika nivåer?',
  a: 'Ja. Arbetsbladen finns i tre nivåer, så att du kan ge alla elever uppgifter som passar deras kunskaper och behov.'
}, {
  q: 'Är filerna utskrivbara?',
  a: 'Ja. Allt levereras som utskrivbara PDF-filer. Du väljer själv vilka sidor du skriver ut, och du kan även använda delar av materialet digitalt.'
}, {
  q: 'Ingår de fem bonusarna?',
  a: `Ja. Alla fem bonusar ingår i paketet utan extra kostnad – allt för ${PRICE}.`
}, {
  q: 'Är det en prenumeration?',
  a: 'Nej. Du betalar en gång och får tillgång till det digitala materialet. Inga återkommande avgifter.'
}, {
  q: 'Kan jag använda materialet på mobil eller surfplatta?',
  a: 'Ja. PDF-filerna kan öppnas på dator, surfplatta och mobil. För att granska layouten före utskrift rekommenderar vi dator eller surfplatta.'
}, {
  q: 'Finns det någon garanti?',
  a: 'Ja. SO KLAR™ har 7 dagars nöjdhetsgaranti. Om materialet inte motsvarar dina förväntningar kan du kontakta oss och begära återbetalning inom 7 dagar från köpet enligt villkoren.'
}];

export const footerLinks = ['Köpvillkor', 'Integritetspolicy', 'Återbetalningspolicy', 'Kontakt'];
